// Vault keys. Every vault has its own random AES-256 key; it encrypts that
// vault's items, categories, requests and activity text. The key is wrapped to
// each member's RSA public key (RSA-OAEP), so the owner's browser can share a
// vault with a client without the server ever holding a usable key.

import { importAesKey, importPublicKey, rsaUnwrap, rsaWrap } from "./cipher";
import { randomBytes } from "./encoding";

export async function newVaultKey(): Promise<{ raw: Uint8Array<ArrayBuffer>; key: CryptoKey }> {
  const raw = randomBytes(32);
  return { raw, key: await importAesKey(raw) };
}

export async function wrapVaultKey(
  vaultKey: CryptoKey,
  publicKeyB64: string,
): Promise<string> {
  const raw = new Uint8Array(await crypto.subtle.exportKey("raw", vaultKey));
  return rsaWrap(await importPublicKey(publicKeyB64), raw);
}

export async function unwrapVaultKey(
  privateKey: CryptoKey,
  wrapped: string,
): Promise<CryptoKey> {
  return importAesKey(await rsaUnwrap(privateKey, wrapped));
}
